import { TERMS_OF_SERVICE_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[TERMS_OF_SERVICE_ROUTE_ID]: {
		// The terms of service are served by the redesign page (RedesignTermsPage) in place at this URL.
		// No legacy modules: the global <RenderModules /> would otherwise render the OLD design below the
		// redesign content. The redesign page owns its own content.
		url: '/terms',
		modules: [],
	},
}
